"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const ToolsCutOptionsButton_1 = __importDefault(require("../../atoms/ToolsCutOptionsButton"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const providers_1 = require("../../providers");
function ToolsCutOptionsPanel({ className, subtype, type, onSelectType, }) {
    const bridge = (0, bridge_1.useBridge)();
    const containerRef = (0, react_1.useRef)(null);
    const [selectedType, setSelectedType] = (0, react_1.useState)(subtype);
    const tools = (0, providers_1.useToolsService)();
    const cutManager = tools === null || tools === void 0 ? void 0 : tools.getThreeDToolManager();
    const selectCutType = (toolType) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateCut({ subtype: toolType });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            type: toolType,
            currentOptions: {
                type: toolType,
                cutMode: type,
                lineIsDrawn: false,
            },
            optionType: 10,
            record: true,
            cutInfo: { action: 'cancel' },
        });
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: toolType,
            currentOptions: {
                type: toolType,
                cutMode: type,
                lineIsDrawn: false,
            },
        });
        cutManager === null || cutManager === void 0 ? void 0 : cutManager.updateCutOptions({
            subtype: toolType,
            type: type,
        });
        onSelectType(toolType);
        setSelectedType(toolType);
    };
    const onClick = (event) => {
        event.stopPropagation();
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(containerRef, events.down, onClick);
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, "data-e2e": 'ToolsCutOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(StyledPushInAnimation, { delay: 200, className: "PushInAnimation", "data-e2e": 'ToolsCutOptionsPanel_StyledPushInAnimation', children: (0, jsx_runtime_1.jsx)(OptionsButton, { selected: selectedType === bridge_schema_1.ToolType.Cut1Side, onClick: () => selectCutType(bridge_schema_1.ToolType.Cut1Side), className: "cutSideButton", "data-e2e": 'ToolsCutOptionsPanel_OptionsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Cut_Side, "data-e2e": 'ToolsCutOptionsPanel_ButtonIcon' }) }) }), (0, jsx_runtime_1.jsx)(StyledPushInAnimation, { delay: 200, "data-e2e": 'ToolsCutOptionsPanel_StyledPushInAnimation', children: (0, jsx_runtime_1.jsx)(OptionsButton, { selected: selectedType === bridge_schema_1.ToolType.CutBetween, onClick: () => selectCutType(bridge_schema_1.ToolType.CutBetween), className: "cutBetweenButton", "data-e2e": 'ToolsCutOptionsPanel_OptionsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Cut_Between, "data-e2e": 'ToolsCutOptionsPanel_ButtonIcon' }) }) }), (0, jsx_runtime_1.jsx)(StyledPushInAnimation, { delay: 200, "data-e2e": 'ToolsCutOptionsPanel_StyledPushInAnimation', children: (0, jsx_runtime_1.jsx)(OptionsButton, { selected: selectedType === bridge_schema_1.ToolType.CutHole, onClick: () => selectCutType(bridge_schema_1.ToolType.CutHole), className: "cutHoleButton", "data-e2e": 'ToolsCutOptionsPanel_OptionsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Cut_Hole, "data-e2e": 'ToolsCutOptionsPanel_ButtonIcon' }) }) })] }));
}
exports.default = ToolsCutOptionsPanel;
const Container = styled_components_1.default.div `
  display: flex;
`;
const OptionsButton = (0, styled_components_1.default)(ToolsCutOptionsButton_1.default) `
  margin: 0 20px 0 0;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 50px;
  height: 50px;
`;
const StyledPushInAnimation = (0, styled_components_1.default)(ui_1.PushInAnimation) `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
